import AudioClipContainer from "../AudioClipContainer";
import React, { useEffect, useRef, useState } from "react";
import { Timer } from "../CountdownTimer";
import { MCQKeyboard } from "../MCQKeyboard";
import { NEW_FORMAT_TOURNAMENT_GAME_TIMER, NEW_FORMAT_TOURNAMENT_GAME_TRIAL_TIMER } from "../../../../../Constants/Commons";
import { Dialog, IconButton } from "@mui/material";
import AppButton from "../../../../Common/AppButton";
import { MCQComprehensionKeyboard } from "../MCQComprehensionKeyboard";

export const ReadingComprehension = ({ currentActiveQuestion, submitGame, updateGameState, gameState, isTrialGame, questionsList, currentActiveIndex = 0, totalQuestions = 1, roundsPerQuestio, props }) => {

    const roundTimerDuration = isTrialGame ? NEW_FORMAT_TOURNAMENT_GAME_TRIAL_TIMER["READING_COMPREHENSION"] : NEW_FORMAT_TOURNAMENT_GAME_TIMER["READING_COMPREHENSION"];
    const [showAudioScreen, setShowAudioScreen] = useState(true);
    const [audioCompleted, setAudioCompleted] = useState(false);
    const [pauseTimer, setPauseTimer] = useState(true);
    const [localQuestionIndex, setLocalQuestionIndex] = useState(0);
    const [showScorePopup, setShowScorePopup] = useState(false);
    const [currentScore, setCurrentScore] = useState({ score: 0, correct: 0 });
    const [showPassagePopup, setShowPassagePopup] = useState(false);
    const [questionData, setQuestionData] = useState({});


    useEffect(() => {
        setShowAudioScreen(true);
        setAudioCompleted(false);
        setPauseTimer(true);
        setLocalQuestionIndex(0);
        setShowScorePopup(false);
        setCurrentScore({ score: 0, correct: 0 });
        setQuestionData(currentActiveQuestion);
        // scoreRef.current = 0;

    }, [currentActiveIndex]);

    const timerRef = useRef(null);
    const scoreRef = useRef(0);

    useEffect(() => {
        if (audioCompleted) {
            setShowAudioScreen(false);
            setAudioCompleted(false);
            setPauseTimer(false);
        }
    }, [audioCompleted]);

    const handleSubmitAnswer = (selectedOption = "", skipped) => {
        //calculate score and and write to db if maingame.
        const currentLocalQuestion = questionData.questions[localQuestionIndex];
        let attempts = gameState.attempts;
        let correctAttempts = gameState.correctAttempts;
        let currentCorrectAttempts = currentScore.correct;
        let accuracyBonus = 0;
        if (selectedOption.toLowerCase() === currentLocalQuestion.answer.toLowerCase()) {
            currentCorrectAttempts = currentCorrectAttempts + 1;
            scoreRef.current = scoreRef.current + 2;
            correctAttempts = correctAttempts + 1;
            attempts = attempts + 1;

            if (localQuestionIndex == questionData.questions.length - 1) {
                if (currentCorrectAttempts == 5) {
                    accuracyBonus = 3;
                } else if (currentCorrectAttempts == 4 || currentCorrectAttempts == 3) {
                    accuracyBonus = 1;
                }
            }

            scoreRef.current = scoreRef.current + accuracyBonus;

            setCurrentScore((prev) => ({
                score: prev.score + 2 + accuracyBonus,
                correct: prev.correct + 1,
                accuracyBonus: accuracyBonus,
            }));
            props.setSnackBar({
                open: true,
                message: "CORRECT",
                type: "success",
                duration: 1500,
            });
        }
        else {
            attempts = attempts + 1;

            if (localQuestionIndex == questionData.questions.length - 1) {
                if (currentCorrectAttempts == 5) {
                    accuracyBonus = 3;
                } else if (currentCorrectAttempts == 4 || currentCorrectAttempts == 3) {
                    accuracyBonus = 1;
                }
            }

            scoreRef.current = scoreRef.current + accuracyBonus;


            setCurrentScore((prev) => ({
                score: prev.score + accuracyBonus,
                correct: prev.correct,
                accuracyBonus: accuracyBonus,
            }));
            props.setSnackBar({
                open: true,
                message: "INCORRECT",
                type: "error",
                duration: 1500,
            });
        }

        const userResponses = gameState.userResponses || [];

        const currentQuestion = {
            question: currentLocalQuestion.question,
            answer: currentLocalQuestion.answer,
            selectedOption: selectedOption,
            timeTaken: roundTimerDuration - timerRef.current,
            currentActiveIndex: currentActiveIndex,
            content: questionData.content,
            accuracyBonus: accuracyBonus,
        }
        userResponses.push(currentQuestion);

        const updatedGameState = {
            ...gameState,
            score: scoreRef.current,
            attempts: attempts,
            correctAttempts: correctAttempts,
            userResponses: userResponses,
        };

        if (!isTrialGame) {
            updateGameState(updatedGameState);
        }

        if (localQuestionIndex < questionData.questions.length - 1) {
            setLocalQuestionIndex(localQuestionIndex + 1);
        }
        else {
            setShowScorePopup(true);
            setPauseTimer(true);
        }

    }

    const handleTimerEnd = () => {
        setShowScorePopup(true);
        setPauseTimer(true);
    }


    const renderScorePopup = () => {
        return (
            <Dialog
                open={showScorePopup}
                onClose={() => { setShowScorePopup(false); submitGame(isTrialGame) }}
                className="register-success"
            >
                <div className="relative flex flex-col bg-primary-gradient text-white h-full overflow-hidden px-6 py-10 leading-6 items-center justify-center">
                    <div
                        style={{ fontFamily: '"Avenir Heavy", Avenir, sans-serif' }}
                        className="text-[18px]"
                    >
                        PASSAGE {currentActiveIndex + 1}/{totalQuestions}
                    </div>

                    <div
                        style={{ fontFamily: '"Avenir Medium", Avenir, sans-serif' }}
                        className="w-[90%] grid grid-cols-2 gap-x-5 mt-4"
                    >
                        {/* Column 1 */}
                        <div className="flex flex-col items-center gap-4">
                            <span className="text-[14px]">Score</span>
                            <span className="text-[14px]">Correct</span>
                            <span className="text-[14px]">Accuracy Bonus</span>
                        </div>

                        {/* Column 2 */}
                        <div className="flex flex-col items-center gap-4">
                            <span className="text-[14px]">{currentScore.score}</span>
                            <span className="text-[14px]">{currentScore.correct}</span>
                            <span className="text-[14px]">{currentScore.accuracyBonus ?? 0}</span>
                        </div>
                    </div>

                    <div className="flex flex-col items-center  justift-center gap-4 mt-[50px]"
                                            style={{ fontFamily: '"Avenir Medium", Avenir, sans-serif' }}
                                            >
                        <span className="text-[14px]">Total Round Score : {scoreRef.current}</span>
                    </div>


                    <AppButton
                        onClick={() => submitGame(isTrialGame)}
                        className="rounded-[115px] min-w-[159px] w-[159px] h-[35px] mt-8 min-h-[35px] self-center"
                    >
                        Proceed To Next
                    </AppButton>
                </div>
            </Dialog>
        );
    }

    const renderParagraphPopup = () => {
        return (
            <Dialog
                open={showPassagePopup}
                onClose={() => setShowPassagePopup(false)}
                className="register-success w-[100vw]"
            >
                <div className="relative bg-white text-black h-full overflow-hidden py-5 flex items-center justify-center">
                    {/* Close button */}

                    <img
                        alt="close"
                        src="/Assets/Icons/cross-icon.svg"
                        className="w-5 h-5 absolute top-0 right-0 p-[2px]"
                        onClick={() => setShowPassagePopup(false)}
                    />

                    {/* Your popup content */}
                    <ReadingComprehensionContainer
                        question={questionData}
                        isPopup={true}
                    />
                </div>
            </Dialog>
        );
    }

    function ReadingComprehensionContainer({ question, isPopup = false }) {
        return (
            <div
                style={{
                    // height: "50vh",
                    height: isPopup ? "60vh" : "50vh",
                    overflowY: "scroll",
                    overflowX: "hidden",
                    border: "2px solid black",
                    padding: "1.5rem",
                    borderRadius: "12px",
                    boxSizing: "border-box",
                    width: "90%",
                    margin: "0 auto",
                    fontSize: "16px",
                    lineHeight: "28px",
                    fontFamily: "Avenir"

                }}
            
               dangerouslySetInnerHTML={{
                __html: question?.content,
                }}
            >
            </div>

        );
    }



    return (
        <div className="h-screen w-screen flex flex-col items-center justify-start">

            {showAudioScreen ? (
                <>
                    <div className="w-full flex justify-between">
                        <div className="flex flex-col items-center justify-center w-full h-full text-[14px]">
                            <span className="text-[20px] text-center">Ques</span>
                            <span className="text-[20px] text-center">
                                {0}/{questionData?.questions?.length}
                            </span>
                        </div>

                        <Timer
                            duration={roundTimerDuration}
                            stroke={5}
                            timerEnd={handleTimerEnd}
                            startTimer={!pauseTimer}
                            key={currentActiveIndex}
                            localTimer={true}
                            color="black"
                            timeRef={timerRef}
                        />

                        <div className="flex flex-col items-center justify-center w-full h-full text-[14px]">
                            <span className="text-[20px] text-center">Score</span>
                            <span className="text-[20px] text-center">{scoreRef.current}</span>
                        </div>
                    </div>

                    <div className="flex flex-col w-full h-full text-[14px] gap-3 mt-[5vh]">
                        <span className="text-[18px] text-center">Passage {currentActiveIndex + 1}/{totalQuestions}</span>

                        <span className="text-[14px] text-center mx-5">Read the passage carefully to answer questions</span>

                        <ReadingComprehensionContainer question={questionData} />

                        <AppButton
                            onClick={() => setAudioCompleted(true)}
                            className="rounded-[115px] min-w-[159px] w-[159px] h-[35px] min-h-[35px] self-center text-lg"
                        >
                            Start
                        </AppButton>
                    </div>
                </>
            ) : (


                <div className="h-[calc(100vh-350px)] w-screen flex flex-col items-center justify-center">

                    <div className="w-full flex justify-between mt-2 fixed top-0">
                        <div className="flex flex-col items-center justify-center w-full h-full text-[14px]">
                            <span className="text-[20px] text-center">Ques</span>
                            <span className="text-[20px] text-center">
                                {localQuestionIndex + 1}/{questionData?.questions?.length}
                            </span>
                        </div>

                        <Timer
                            duration={roundTimerDuration}
                            stroke={5}
                            timerEnd={handleTimerEnd}
                            startTimer={!pauseTimer}
                            key={currentActiveIndex}
                            localTimer={true}
                            color="black"
                            timeRef={timerRef}
                        />

                        <div className="flex flex-col items-center justify-center w-full h-full text-[14px]">
                            <span className="text-[20px] text-center">Score</span>
                            <span className="text-[20px] text-center">{scoreRef.current}</span>
                        </div>
                    </div>

                    <div className="flex flex-col w-full text-[14px] gap-[10vh] mt-[5vh]">
                        <span className="text-[18px] mx-5">
                            {questionData.questions[localQuestionIndex].question}
                        </span>
                    </div>

                    {/* 3. MCQKeyboard fixed to the viewport bottom */}
                    <div className="fixed bottom-0 left-0 w-full bg-white">
                        <div className="flex flex-col items-center justify-center w-full h-full text-[14px] mb-4">

                            <AppButton
                                onClick={() => setShowPassagePopup(true)}
                                variant="secondary"
                                className="rounded-[115px] min-w-[159px] w-[159px] h-[35px] min-h-[35px] self-center border-black border-[2px] text-black"
                            >

                                View Passage
                            </AppButton>
                        </div>
                        <MCQComprehensionKeyboard
                            question={questionData.questions[localQuestionIndex]}
                            onSubmit={handleSubmitAnswer}
                            enableSkip={false}
                        />

                    </div>

                    {renderScorePopup()}
                    {renderParagraphPopup()}
                </div>
            )
            }
        </div>
    );
}